import { Field, getIn } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import FormField from './FormField';

export const getFormikProps = (
  props,
  { field, form: { errors, setFieldTouched, setFieldValue, touched } },
) => {
  const { type } = props;
  const { name } = field;
  // using `getIn` for FieldArray fields
  const error = getIn(touched, name) ? getIn(errors, name) : null;

  const baseProps = {
    ...field,
    ...props,
    error,
    onChange: (value) => {
      field.onChange(value);
      if (props.onChange) {
        props.onChange(value);
      }
    },
  };

  if (type === 'select') {
    return {
      ...baseProps,
      onBlur: () => setFieldTouched(field.name, true),
      onChange: (value) => {
        setFieldValue(field.name, value);
        if (props.onChange) {
          props.onChange(value);
        }
      },
    };
  }

  return baseProps;
};

const propTypes = {
  component: PropTypes.elementType,
};

const defaultProps = {
  component: null,
};

const FormikFormField = ({ component = null, ...props }) => (
  <Field {...props}>
    {(formikProps) => (
      <FormField
        {...getFormikProps(props, formikProps)}
        component={component}
      />
    )}
  </Field>
);

FormikFormField.propTypes = propTypes;
FormikFormField.defaultProps = defaultProps;

export default FormikFormField;
